import EventAgent from '@hotmart/event-agent-js'
import { DATA_VERSION, EVENT_VERSION } from './constants'
import { System, Platform } from './enums'
import type { DatahubProps } from './types'

const PROD_HOST = 'hotmart.com'

class DatahubUtils {
  private static getMode(hostUrl: string) {
    return hostUrl.includes(PROD_HOST) ? 'production' : 'staging'
  }

  static sendEvent(datahubObject: DatahubProps, system = System.MEMBERSHIP_COMMUNITY) {
    EventAgent.mode = this.getMode(location.host)

    EventAgent.send({
      system,
      data_version: DATA_VERSION,
      event_version: EVENT_VERSION,
      action: datahubObject.action,
      entity: datahubObject.entity,
      event: {
        ...datahubObject.event,
        platform: Platform.WEB
      }
    })
  }
}

export default DatahubUtils
